import React, { useState, useEffect } from 'react';
import { rankAPI } from '../../api';

const AdminRanks = () => {
  const [ranks, setRanks] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchRanks();
  }, []);

  const fetchRanks = async () => {
    try {
      setLoading(true);
      const response = await rankAPI.getAllRanks();
      setRanks(response.data || []);
    } catch (error) {
      console.error('Error fetching ranks:', error);
      setRanks([]);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="animate-spin rounded-full h-12 w-12 border-4 border-[#E4572E] border-t-transparent"></div>
      </div>
    );
  }

  return (
    <div className="bg-[#F8FAFC] p-6 rounded-2xl">

      {/* Header */}
      <div className="flex justify-between items-center mb-10">
        <div>
          <h2 className="text-3xl font-bold text-[#0F2F3D]">
            Rank System
          </h2>
          <p className="text-gray-500 mt-1">
            Configure rank requirements and reward structure
          </p>
        </div>

        <button
          onClick={fetchRanks}
          className="px-4 py-2 bg-gradient-to-r from-[#E4572E] to-[#F47C4D] text-white rounded-lg shadow hover:opacity-90 transition-all duration-300"
        >
          Refresh
        </button>
      </div>

      {/* Rank Cards */}
      {ranks.length > 0 ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">

          {ranks.map((rank, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-md p-6 border-t-4 border-[#E4572E] hover:shadow-xl transition-all duration-300"
            >

              {/* Rank Title */}
              <div className="flex items-center justify-between mb-5">
                <h3 className="text-xl font-bold text-[#E4572E]">
                  {rank.rankName}
                </h3>
                <div className="w-10 h-10 bg-[#0F2F3D]/10 rounded-full flex items-center justify-center text-[#0F2F3D] font-bold">
                  {rank.displayOrder}
                </div>
              </div>

              {/* Details */}
              <div className="space-y-3 text-sm">

                <div className="flex justify-between border-b pb-2">
                  <span className="text-gray-600">Business Required</span>
                  <span className="font-semibold text-[#0F2F3D]">
                    ₹{rank.businessRequired?.toLocaleString() || 0}
                  </span>
                </div>

                <div className="flex justify-between border-b pb-2">
                  <span className="text-gray-600">Reward Amount</span>
                  <span className="font-bold text-green-600">
                    ₹{rank.rewardAmount?.toLocaleString() || 0}
                  </span>
                </div>

                <div className="flex justify-between border-b pb-2">
                  <span className="text-gray-600">Criteria</span>
                  <span className="font-medium text-[#0F2F3D]">
                    {rank.criteria}
                  </span>
                </div>

                <div className="flex justify-between">
                  <span className="text-gray-600">Display Order</span>
                  <span className="px-3 py-1 rounded-full bg-[#E4572E]/10 text-[#E4572E] text-xs font-semibold">
                    {rank.displayOrder}
                  </span>
                </div>

              </div>
            </div>
          ))}

        </div>
      ) : (
        <div className="text-center py-16 text-gray-500">
          No ranks configured yet.
        </div>
      )}

    </div>
  );
};

export default AdminRanks;